module.exports = __webpack_public_path__ + "img/pmb5.eea02f4d.jpg";